module.exports = "<div class=\"container\">\n    <div class=\"titleSection\">\n        {{ 'REC.title' | translate }}\n    </div>\n    {{ 'REC.texto1' | translate }}\n    <textarea highlight-js [options]=\"{}\" [lang]=\"'typescript'\">\npublic recuperarPass(emailAddress){\n  this.angularFireAuth.auth.sendPasswordResetEmail(emailAddress).then(() => {\n\n  }).catch((error) => {\n      alert(error);\n  });   \n}\n    </textarea>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Practicos/rec-pass/rec-pass.component.html
// module id = ./src/app/Practicos/rec-pass/rec-pass.component.html
// module chunks = main